import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { globals } from '../Globals/Globals';

const ProtectedRoute = (props) => {
  
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if (globals.parameters.debugging)
    console.log("children->", props.children)

  if (!isAuthenticated) {
    return <Navigate to={props.default?props.default:"/login-page"} />;
  }

  return props.children;
};

export default ProtectedRoute;  